import {Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ExgPopupComponent} from '../../modal/exg-popup/exg-popup.component';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'exg-pager',
  templateUrl: './exg-pager.component.html',
  styles: []
})
export class ExgPagerComponent extends ExcTranslation implements OnInit {


  static id: string = 'popup-' + Math.random().toString(36).substring(2);
  @ViewChild('pager_popup', {read: ExgPopupComponent}) menu!: ExgPopupComponent;
  @ContentChild('popupTemplate') popupTemplate!: TemplateRef<ElementRef>;
  @ContentChild('leftTemplate') leftTemplate!: TemplateRef<ElementRef>;
  @ContentChild('rightTemplate') rightTemplate!: TemplateRef<ElementRef>;


  @Input() pagingSource: {
    [key: string]: any,
    pagingPage: number,
    pagingPageSize: number,
    pagingTotalPages: number,
    pagingTotalRows: number,
    pagingStartRow: number,
    pagingEndRow: number
  } = {pagingPage: 0, pagingPageSize: 0, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0, pagingEndRow: 0};

  @Input() pagertext = 'von';

  @Output() PageChange: EventEmitter<number> = new EventEmitter<number>();


  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  onPageChange(page: number): void {
    if (!this.pagingSource) {
      return;
    }
    if (page >= 1 && page <= this.pagingSource.pagingTotalPages) {
      this.PageChange.emit(page);
    }
  }


  openMenu(e: any): void {
    this.menu.openAboveCenter(e);
  }

  private getPages(): Array<any> {
    if (!this.pagingSource) {
      return [];
    }
    return new Array<any>(this.pagingSource.pagingTotalPages);
  }
}
